import React, { Component } from "react";
import dayjs from "dayjs";
import { BASE_API } from "../../utils/constants";
import { fetchTeamBySlug } from "../../utils/helpers";
import "../../css/Analytics.scss";

export default class Analytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      org: null,
      teamSlug: null,
      team: null,
      loading: true,
      error: null,
      players: [],
      from: dayjs().subtract(3, "month").format("YYYY-MM-DD"),
      to: dayjs().format("YYYY-MM-DD"),
      sortBy: "games_played",
      sortDir: "desc",
    };
  }

  async componentDidMount() {
    const wrapper = document.getElementById("echipaDashboard");
    if (wrapper) wrapper.classList.add("layout-xl-width");

    const urlParams = new URLSearchParams(window.location.search);
    const org = urlParams.get("org");
    const teamSlug = urlParams.get("echipa");

    if (!teamSlug) {
      this.setState({
        error: "Parametrul ?echipa lipsește din URL",
        loading: false,
      });
      return;
    }

    try {
      const team = await fetchTeamBySlug(teamSlug);
      this.setState({ org, teamSlug, team }, () => this.fetchAnalytics());
    } catch (err) {
      this.setState({ error: err.message, loading: false });
    }
  }

  async fetchAnalytics() {
    const { team, from, to } = this.state;
    if (!team?.id) return;

    this.setState({ loading: true });
    try {
      const qs = `team_id=${team.id}&from=${from}&to=${to}`;
      const res = await fetch(`${BASE_API}/api/analytics/players?${qs}`);
      const json = await res.json();
      if (!res.ok) throw new Error(json.error || "Eroare la încărcarea datelor");
      this.setState({ players: json.players || [], loading: false });
    } catch (err) {
      console.error("Eroare fetch analytics:", err);
      this.setState({ error: err.message, loading: false });
    }
  }

  /* ───────────── SORTARE ───────────── */
  handleSort = (key) => {
    this.setState((prev) => {
      const newDir =
        prev.sortBy === key ? (prev.sortDir === "asc" ? "desc" : "asc") : "desc";
      return { sortBy: key, sortDir: newDir };
    });
  };

  getSortedPlayers() {
    const { players, sortBy, sortDir } = this.state;
    const sorted = [...players].sort((a, b) => {
      const valA = a[sortBy] ?? 0;
      const valB = b[sortBy] ?? 0;
      if (typeof valA === "string") return valA.localeCompare(valB);
      return sortDir === "asc" ? valA - valB : valB - valA;
    });
    return sorted;
  }

  renderTable() {
  const players = this.getSortedPlayers();
  const { sortBy, sortDir } = this.state;

  const SortIcon = ({ col }) => {
    if (sortBy !== col) return null;
    return <span className="sort-arrow">{sortDir === "asc" ? "▲" : "▼"}</span>;
  };

  if (!players.length)
    return <div className="ucl-empty">Nu există date pentru perioada selectată.</div>;

  return (
    <div className="ucl-table">
      <div className="table-head">
        <div className="th rank-col">#</div>
        <div className="th" onClick={() => this.handleSort("name")}>
          Jucător <SortIcon col="name" />
        </div>
        <div className="th" onClick={() => this.handleSort("position")}>
          Poziție <SortIcon col="position" />
        </div>
        <div className="th sortable" onClick={() => this.handleSort("games_played")}>
          Meciuri <SortIcon col="games_played" />
        </div>
        <div className="th sortable" onClick={() => this.handleSort("minutes_played")}>
          Minute <SortIcon col="minutes_played" />
        </div>
        <div className="th sortable" onClick={() => this.handleSort("goals")}>
          Goluri <SortIcon col="goals" />
        </div>
        <div className="th sortable" onClick={() => this.handleSort("assists")}>
          Assist <SortIcon col="assists" />
        </div>
        <div className="th sortable" onClick={() => this.handleSort("yellow_cards")}>
          🟨 <SortIcon col="yellow_cards" />
        </div>
        <div className="th sortable" onClick={() => this.handleSort("red_cards")}>
          🟥 <SortIcon col="red_cards" />
        </div>
        <div className="th sortable" onClick={() => this.handleSort("total_rating")}>
          Rating <SortIcon col="total_rating" />
        </div>
        <div className="th sortable" onClick={() => this.handleSort("trainings_total")}>
          Antr. <SortIcon col="trainings_total" />
        </div>
        <div className="th sortable" onClick={() => this.handleSort("trainings_present")}>
          Prezent <SortIcon col="trainings_present" />
        </div>
      </div>

      <div className="table-body">
        {players.map((p, index) => (
          <div key={p.player_id} className="row">
            <div className="cell rank">{index + 1}</div>
            <div className="cell player">
              <div className="name">{p.name}</div>
            </div>
            <div className="cell pos">{p.position}</div>
            <div className="cell">{p.games_played}</div>
            <div className="cell">{p.minutes_played}</div>
            <div className="cell">{p.goals}</div>
            <div className="cell">{p.assists}</div>
            <div className="cell">{p.yellow_cards}</div>
            <div className="cell">{p.red_cards}</div>
            <div className="cell">{p.total_rating}</div>
            <div className="cell">{p.trainings_total}</div>
            <div className="cell">{p.trainings_present}</div>
          </div>
        ))}
      </div>

      <div className="table-foot">
        <span className="hint">* click pe coloane pentru sortare</span>
      </div>
    </div>
  );
}


  render() {
    const { loading, error, team, from, to } = this.state;

    if (loading)
      return (
        <div className="ucl-analytics">
          <div className="ucl-spinner"></div>
        </div>
      );
    if (error)
      return (
        <div className="ucl-analytics">
          <div className="ucl-empty">{error}</div>
        </div>
      );

    return (
      <div className="ucl-analytics">
        {/* HEADER */}
        <div className="ucl-header">
          <div className="ucl-title">
            <div className="h1">Analytics – {team?.name}</div>
            {/* <div className="subtitle">overview echipă</div> */}
          </div>
          <div className="ucl-actions">
            <button className="ucl-btn ghost" onClick={() => window.location.reload()}>
              Actualizează
            </button>
          </div>
        </div>

        {/* TOOLBAR */}
        <div className="ucl-toolbar">
          <div className="ucl-filters">
            <div className="filter is-active">
              <span>De la</span>
              <input
                type="date"
                value={from}
                onChange={(e) => this.setState({ from: e.target.value })}
              />
            </div>
            <div className="filter is-active">
              <span>Până la</span>
              <input
                type="date"
                value={to}
                onChange={(e) => this.setState({ to: e.target.value })}
              />
            </div>
            <button className="ucl-btn primary" onClick={() => this.fetchAnalytics()}>
              Filtrează
            </button>
          </div>
        </div>

        {/* KPI */}
        <div className="ucl-kpis">
          <div className="kpi">
            <div className="label">Total jucători</div>
            <div className="value">{this.state.players.length}</div>
          </div>
          <div className="kpi">
            <div className="label">Goluri totale</div>
            <div className="value">
              {this.state.players.reduce((s, p) => s + (p.goals || 0), 0)}
            </div>
          </div>
          <div className="kpi">
            <div className="label">Minute totale</div>
            <div className="value">
              {this.state.players.reduce((s, p) => s + (p.minutes_played || 0), 0)}
            </div>
          </div>
          <div className="kpi">
            <div className="label">Antrenamente</div>
            <div className="value">
              {(() => {
               console.log(this.state)
                return this.state?.players?.[0].trainings_total;
              })()}
            </div>
          </div>
        </div>

        {/* TABLE */}
        {this.renderTable()}
      </div>
    );
  }
}
